import React from "react";
import { UserInfoContainer, Wallet } from "./style";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

const UserInfo = props => {
  return (
    <UserInfoContainer
      onClick={() => props.history.push("/user-account-setting")}
    >
      <div className="user-name">{props.userName}</div>
      <div className="profile-link">
        <Link to="/user-account-setting">
          مشاهده حساب کاربری
          <i className="icon mapsa-left-arrow-chevron" />
        </Link>
      </div>
      <Wallet>
        <div className="label">
          <i className="icon mapsa-my-credit" />
          امتیاز‌های من
        </div>
        <div className="amount">
          {parseInt(props.wallet / 10).toLocaleString("fa")}
          <span>تومان</span>
        </div>
      </Wallet>
    </UserInfoContainer>
  );
};

export default withRouter(UserInfo);
